import { z } from 'zod'
import { AccountStatus } from '~/enums/account-status-code'
import { TrueFalse } from '~/enums/true-false'

/**
 * 帳號 - 多筆資料 Schema
 */
export const accountListDataSchema = z.object({
  /** 帳號 */
  accountNo: z.string(),
  /** 公司/部門 */
  companyDept: z.string(),
  /** 建立人員 */
  createUser: z.string(),
  /** 是否啟用 */
  isEnable: z.nativeEnum(TrueFalse),
  /** 手機 */
  phone: z.string(),
  /** 真實姓名 */
  realName: z.string(),
  /** 帳號角色 */
  role: z.string(),
  /** 審核狀態代碼 */
  statusCode: z.nativeEnum(AccountStatus),
  /** 審核狀態名稱 */
  statusName: z.string()
})

/**
 * 帳號 - 多筆資料
 */
export interface AccountListData
  extends z.infer<typeof accountListDataSchema> {}
